import React from "react";
import Container from "../../../utility/ui-components/container";
import Section from "../../../utility/ui-components/section";
import SectionHeading from "../../../utility/ui-components/sectionHeading";
import home from "../../../../common/assets/data/home";
import { Link } from "react-router-dom";
import { AnimationOnScroll } from "react-animation-on-scroll";
import Button from "../../../utility/ui-components/button";
function RequirementSection() {
  const data = home.channelPartnerSection;
  console.log(data)
  return (
    <Section className="bg-white">
      <Container>
        <div className="border-2 border-secondary rounded-2xl px-6 py-2">
          <div className="grid md:grid-cols-5 gap-2 items-center mx-auto max-w-screen-xl">
            <div className="md:col-span-3">
              <SectionHeading heading={data.Heading} />
              <p className="text-center md:text-left text-base md:text-lg">
                {data.paragraph}
              </p>
              {data.buttons.map((button, index) => (
                <div key={index + 1} className="text-center md:text-left my-5 md:ml-0">
                  <Link to={button.path}>
                    <Button  type="button" button={button} />
                  </Link>
                </div>
              ))}
            </div>
            <div className="md:col-span-2 md:w-[300px] m-auto">
              <img
                className="w-full rounded-lg"
                src={data.aboutImg.img}
                alt={data.aboutImg.alt}
              />
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}
export default RequirementSection;
